<template>
  <div>
    <div
      v-if="showContainer"
      :style="[
        borderLeftColor
          ? { 'border-left': `${borderLeftColor} solid 5px` }
          : {},
      ]"
      :class="[
        classMain,
        borderLeftColor ||
          `border-left--color-${borderColor ? borderColor : 'secondary-12'}`,
        { 'border--left': hasBorder },
      ]"
      class="bg-secondary-3 border-radius--light"
    >
      <div class="row">
        <div
          :class="{ 'gradient-toggle': hasGradient && hasToggle }"
          class="ml-3 d-flex align-items-center px-2"
        >
          <em
            v-if="hasToggle"
            :class="{
              'fa-chevron-circle-right color-primary-2': !isOpen,
              'fa-chevron-circle-down color-primary-1': isOpen,
            }"
            class="far font-20"
            @click="open"
          />
        </div>
        <div :class="{ 'ml-2': hasGradient }" class="col p-2">
          <slot />
        </div>
      </div>
    </div>
    <div
      v-if="isOpen"
      :class="classPanel"
      class="bg-secondary-3 border-radius--light p-0"
    >
      <slot name="edition" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Callout',
  props: {
    hasBorder: {
      type: Boolean,
      default: () => true,
    },
    hasToggle: {
      type: Boolean,
      default: () => true,
    },
    borderColor: {
      type: String,
      default: () => null,
    },
    borderLeftColor: { type: String, default: null },
    opened: {
      type: Boolean,
      default: () => false,
    },
    controlled: {
      type: Boolean,
      default: () => false,
    },
    classMain: {
      type: String,
      default: () => '',
    },
    classPanel: {
      type: String,
      default: () => '',
    },
    hasGradient: {
      type: Boolean,
      default: () => true,
    },
    showContainer: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: null,
    };
  },
  watch: {
    opened: {
      handler(value) {
        this.isOpen = value;
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      if (!this.controlled) {
        this.isOpen = !this.isOpen;
      } else {
        this.$emit('click:open');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.border--left {
  border-left-style: solid;
  border-left-width: 5px;
}

.gradient-toggle {
  box-shadow: 5px 0px 5px #e2e2e2;
}

.border-left--color-secondary-12 {
  border-left-color: #e8e8e8;
}
.color-primary-2 {
  color: #ff7058;
}
.color-primary-1 {
  color: #2db782;
}
.font-20 {
  font-size: 20px;
}
.bg-secondary-3 {
  background-color: #f7f7f7;
}
.border-radius--light {
  border-radius: 5px;
}
.bg-secondary-23 {
  background-color: #fcc9c8;
}
.bg-secondary-23 {
  background-color: #fcc9c8;
}
.bg-primary-15 {
  background-color: #a4e5b2;
}
.bg-primary-11 {
  background-color: #a4e5b2;
}
.bg-secondary-24 {
  background-color: #d5b899;
}
.bg-secondary-25 {
  background-color: #ac99c1;
}
</style>
